import { Component, OnInit } from '@angular/core';
import { AccountDetailsService } from '../services/account-details.service';
import { LoginService } from '../services/login.service';
import { AccountDetails } from '../models/AccountDetail';
import { AccountDeviceModel } from '../models/AccountDevicesModel';
import { CurrentAccount } from '../models/AccountModel';
import { UserInfoModel } from '../models/UserInfoModel';
import { Router } from '@angular/router';

@Component({
    selector: 'app-manage-accounts-container',
    templateUrl: './manage-accounts-container.component.html',
    styleUrls: ['./manage-accounts-container.component.css']
})

export class ManageAccountsContainerComponent implements OnInit {

  acctDetails: AccountDetails;
  customerInfo: UserInfoModel;
  allCustomerInfo = Array<UserInfoModel>();
  accountsWithDevices: AccountDeviceModel;
  currentAccount: CurrentAccount;
  allAccounts = Array<CurrentAccount>();

  constructor(
    private loginService: LoginService,
    private accountDetailsService: AccountDetailsService,
    private router: Router
  ) {

  }
  ngOnInit() {
    this.loginService.getCustomerAccounts()
      .subscribe(
        (accts) => {
          if (accts) {
            this.accountsWithDevices = accts;
            let firstAcct = this.accountsWithDevices[0];
            //current acct
            this.currentAccount = {
              OrgUnitId: firstAcct.orgUnitId,
              DeviceId: firstAcct.deviceId,
              AccountId: firstAcct.accountId
            }
            //all accts
            for (var i = 0; i < accts.length; i++) {

              this.allAccounts.push({
                OrgUnitId: accts[i].orgUnitId,
                DeviceId: accts[i].deviceId,
                AccountId: accts[i].accountId
              });
            }

            //all user info
            for (var i = 0; i < this.allAccounts.length; i++) {
              this.accountDetailsService.getUserInfo(
                this.allAccounts[i].OrgUnitId.toString(),
                this.allAccounts[i].AccountId.toString()
              ).subscribe((res: any) => {
                if (res.success) {
                  this.allCustomerInfo.push({
                    AccountId: res.response.accountId,
                    AccountNumber: res.response.accountNumber,
                    WebAccessCode: res.response.webAccessCode,
                    Email: res.response.email,
                    FirstName: res.response.firstName,
                    LastName: res.response.lastName,
                    LastFourSSN: res.response.lastFourSSN,
                    OrgUnitId: res.response.orgUnitId,
                    Zipcode: res.response.zipcode,
                    AccountUUID: res.response.accountUUID,
                    UtilityNumber: res.response.utilityNumber === null ? "" : res.response.utilityNumber,
                    DeviceId: res.response.deviceId,
                    Address1: res.response.address1,
                    Address2: res.response.address2 === null ? "" : res.response.address2,
                    City: res.response.city,
                    State: res.response.state,
                    CustomerContactMethods: res.response.CustomerContactMethods,
                    Budget: res.response.Budget
                  })
                } else {
                  console.log('failed to retrieve account data');
                }
              });
            }
          }
          else {
            console.error('error: customer has no accounts');
          }
        },
        (err) => console.error(err)
      );
  }

  goToRegister() {
    this.router.navigate(['/MyProfile/AddAccount']);
  }
}



// WEBPACK FOOTER //
// ./src/app/manage-accounts-container/manage-accounts-container.component.ts